"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/campaign-changelog.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Fcampaign-changelog.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Removed = exports.Assigned = exports.CampaignChangelog = void 0;
const protobufPackage = 'com.step.referral.proto';
function createBaseCampaignChangelog() {
    return { assigned: undefined, removed: undefined };
}
exports.CampaignChangelog = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.assigned)) {
            message.assigned = exports.Assigned.fromJSON(object.assigned);
        }
        if (isSet(object.removed)) {
            message.removed = exports.Removed.fromJSON(object.removed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.assigned !== undefined) {
            obj.assigned = exports.Assigned.toJSON(message.assigned);
        }
        if (message.removed !== undefined) {
            obj.removed = exports.Removed.toJSON(message.removed);
        }
        return obj;
    },
    create(base) {
        return exports.CampaignChangelog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCampaignChangelog();
        message.assigned = (object.assigned !== undefined && object.assigned !== null)
            ? exports.Assigned.fromPartial(object.assigned)
            : undefined;
        message.removed = (object.removed !== undefined && object.removed !== null)
            ? exports.Removed.fromPartial(object.removed)
            : undefined;
        return message;
    },
};
function createBaseAssigned() {
    return { campaign: '', assignedAt: '0' };
}
exports.Assigned = {
    fromJSON(object) {
        const message = {
            campaign: isSet(object.campaign) ? globalThis.String(object.campaign) : '',
            assignedAt: isSet(object.assignedAt) ? globalThis.String(object.assignedAt) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.assignedAt !== '0') {
            obj.assignedAt = message.assignedAt;
        }
        return obj;
    },
    create(base) {
        return exports.Assigned.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssigned();
        message.campaign = object.campaign ?? '';
        message.assignedAt = object.assignedAt ?? '0';
        return message;
    },
};
function createBaseRemoved() {
    return { campaign: '', removedAt: '0' };
}
exports.Removed = {
    fromJSON(object) {
        const message = {
            campaign: isSet(object.campaign) ? globalThis.String(object.campaign) : '',
            removedAt: isSet(object.removedAt) ? globalThis.String(object.removedAt) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.removedAt !== '0') {
            obj.removedAt = message.removedAt;
        }
        return obj;
    },
    create(base) {
        return exports.Removed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoved();
        message.campaign = object.campaign ?? '';
        message.removedAt = object.removedAt ?? '0';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=campaign-changelog.js.map